/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const DELETEINTERNSHIPBYID= createAsyncThunk(
  "deleteInternshipById/deleteInternshipById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteInternshipByIdSlice = createSlice({
  name: "deleteInternshipByIdSlice",
  initialState: {
    deleteInternshipById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteInternshipById: (state) => {
        state.deleteInternshipById.loading = false
        state.deleteInternshipById.error = false
        state.deleteInternshipById.data = []
        state.deleteInternshipById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETEINTERNSHIPBYID.fulfilled, (state, action) => {
      state.deleteInternshipById = {
        ...state.deleteInternshipById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEINTERNSHIPBYID.pending, (state, action) => {
      state.deleteInternshipById = {
        ...state.deleteInternshipById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEINTERNSHIPBYID.rejected, (state, action) => {
      state.deleteInternshipById = {
        ...state.deleteInternshipById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteInternshipByIdAction = {
    DELETEINTERNSHIPBYID,
};

export { deleteInternshipByIdAction };
export default deleteInternshipByIdSlice.reducer;
export const {setInitialStateOfdeleteInternshipById} = deleteInternshipByIdSlice.actions